module.exports = __webpack_public_path__ + "img/b_2.03c53e16.png";